module.exports = __webpack_public_path__ + "static/media/sub-banner.df2db262.jpg";